<template>
	<!-- 80 mm receipt (spec §6.6 layout, Vue 2 port). Renders a server
	     ReceiptModel with no business logic. -->
	<div class="pos-receipt" :class="{ 'pos-receipt--screen': screen }">
		<div v-if="m.header.logo_data_url" class="pr-center">
			<img class="pr-logo" :src="m.header.logo_data_url" alt="" />
		</div>
		<div v-if="m.header.shop_name" class="pr-center pr-shop">{{ m.header.shop_name }}</div>
		<div v-if="m.header.address" class="pr-center pr-pre">{{ m.header.address }}</div>
		<div v-if="m.header.phone" class="pr-center">{{ m.header.phone }}</div>
		<div v-if="m.header.header_note" class="pr-center pr-pre">{{ m.header.header_note }}</div>

		<div class="pr-center pr-title">{{ m.title }}</div>
		<div v-if="m.flags.reprint" class="pr-center">พิมพ์ซ้ำ</div>
		<div v-if="m.flags.voided" class="pr-center"><span class="pr-void">ยกเลิกแล้ว</span></div>

		<div>เลขที่ {{ m.bill_no }}</div>
		<div>วันที่ {{ m.datetime_text }}</div>
		<div>เครื่อง {{ m.device_code }}&nbsp;&nbsp;พนักงาน {{ m.seller_name }}</div>
		<div v-if="m.event_name">งาน {{ m.event_name }}</div>

		<template v-if="m.customer">
			<div v-if="m.customer.name">ลูกค้า {{ m.customer.name }}</div>
			<div v-if="m.customer.phone_masked">โทร {{ m.customer.phone_masked }}</div>
			<div v-if="m.customer.address_text" class="pr-pre">{{ m.customer.address_text }}</div>
		</template>

		<div class="pr-rule"></div>
		<div v-for="(l, i) in m.lines" :key="'l' + i" class="pr-line">
			<div>{{ l.name }}</div>
			<div class="pr-row">
				<span>{{ l.qty }} x {{ l.unit_price_text }}</span>
				<span>{{ l.amount_text }}</span>
			</div>
			<div v-for="(c, j) in l.components || []" :key="'c' + j" class="pr-comp">- {{ c.name }} x{{ c.qty }}</div>
		</div>
		<div class="pr-rule"></div>

		<div class="pr-row"><span>รวม</span><span>{{ m.subtotal_text }}</span></div>
		<div v-if="m.discount_text" class="pr-row"><span>{{ m.discount_label }}</span><span>{{ m.discount_text }}</span></div>
		<div class="pr-row pr-total"><span>ยอดสุทธิ</span><span>{{ m.total_text }}</span></div>
		<div>ชำระโดย {{ m.payment.method_label }}</div>
		<div v-if="m.payment.received_text" class="pr-row"><span>รับเงิน</span><span>{{ m.payment.received_text }}</span></div>
		<div v-if="m.payment.change_text" class="pr-row"><span>เงินทอน</span><span>{{ m.payment.change_text }}</span></div>

		<div v-if="m.footer.text" class="pr-center pr-pre pr-footer">{{ m.footer.text }}</div>
		<div v-if="qrPath" class="pr-center">
			<svg class="pr-qr" :viewBox="`0 0 ${qrSize} ${qrSize}`" shape-rendering="crispEdges">
				<rect :width="qrSize" :height="qrSize" fill="#fff" />
				<path :d="qrPath" fill="#000" />
			</svg>
			<div v-if="m.footer.qr_caption">{{ m.footer.qr_caption }}</div>
		</div>
	</div>
</template>

<script>
import { qrMatrix } from "@/utils/qrcode";
import { posEnsureReceiptCss } from "@/utils/posReceiptCss";

const EMPTY = {
	header: {},
	title: "ใบเสร็จรับเงิน",
	lines: [],
	payment: {},
	footer: {},
	flags: {}
};

export default {
	name: "PosReceiptPreview",
	props: {
		model: { type: Object, default: null },
		// screen = a framed preview with a shadow (settings / bill view);
		// false = bare markup for the print window.
		screen: { type: Boolean, default: true }
	},
	created() {
		posEnsureReceiptCss();
	},
	computed: {
		m() {
			const src = this.model || {};
			return {
				...EMPTY,
				...src,
				header: { ...(src.header || {}) },
				payment: { ...(src.payment || {}) },
				footer: { ...(src.footer || {}) },
				flags: { ...(src.flags || {}) },
				lines: Array.isArray(src.lines) ? src.lines : []
			};
		},
		qr() {
			const text = this.m.footer.qr_text;
			if (!text) return null;
			try {
				return qrMatrix(String(text), "MEDIUM");
			} catch (e) {
				return null;
			}
		},
		qrSize() {
			return this.qr ? this.qr.length + 2 : 0;
		},
		qrPath() {
			if (!this.qr) return "";
			let d = "";
			this.qr.forEach((row, y) => {
				row.forEach((dark, x) => {
					if (dark) d += `M${x + 1} ${y + 1}h1v1h-1z`;
				});
			});
			return d;
		}
	}
};
</script>
